module.exports = __webpack_public_path__ + "static/media/idea.b2fc5876.svg";